/* eslint-disable no-unused-expressions */
import withAdminDashboard from "../../../HOC/withAdminDashboard";
import withActivityLayout from "../../../../../components/Common/HOC/withActivityLayout";

const BidInvitation = () => (
  withActivityLayout(() => null)({
    dataSheet: true,
    title: "Bid Invitation",
    extraCrumbs: [
      {
        url: "#",
        title: "Bid Invitation",
      },
    ]
  })
);

export default withAdminDashboard(BidInvitation);
